import { useEffect } from "react";
import {
  Path,
  PathValue,
  UnpackNestedValue,
  UseFormSetValue,
} from "react-hook-form";

function useDynamicDefaultValue<T>(
  fieldName: Path<T>,
  defaultValue: UnpackNestedValue<PathValue<T, Path<T>>> | undefined,
  getValues: (fieldName: Path<T>) => UnpackNestedValue<PathValue<T, Path<T>>>,
  setValue: UseFormSetValue<T>
) {
  useEffect(() => {
    const currentValue = getValues(fieldName);
    if (!currentValue && defaultValue) {
      setValue(fieldName, defaultValue);
    }
  }, [fieldName, defaultValue, getValues, setValue]);
}

export default useDynamicDefaultValue;
